import { render, staticRenderFns } from "./InvoiceRemarkListAddNew.vue?vue&type=template&id=56daa219&"
import script from "./InvoiceRemarkListAddNew.vue?vue&type=script&lang=js&"
export * from "./InvoiceRemarkListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceRemarkListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports